export interface KeyShoutFormValues {
	heading: string;
	content: string;
	buttonLink: string;
	webview: boolean;
	/** Hashtag UUID this key shout links to. When set, the link opens the social feed. */
	feedId?: string | null;
	/** Transient hashtag object so the picker can render the chip without re-fetching. */
	selectedFeed?: { uuid: string; name: string } | null;
	/** Blob reference returned by the upload pipeline (null when no image set). */
	image: string | null;
	/** IDs of the groups this key shout is restricted to. Empty = everyone. */
	audienceGroupIds: number[];
}

export function formValuesToKeyShout(
	data: KeyShoutFormValues,
	id?: number
): Partial<KeyShout> & { audienceGroupIds: number[] } {
	const hasFeed = Boolean(data.feedId);
	return {
		...(id !== undefined && { id }),
		heading: data.heading,
		content: data.content || null,
		buttonLink: hasFeed ? null : data.buttonLink || null,
		webview: hasFeed ? false : data.buttonLink ? data.webview : false,
		feedId: data.feedId,
		modalLink: null,
		audienceGroupIds: data.audienceGroupIds ?? []
	};
}
